import { Component, EventEmitter, Output } from '@angular/core';
import { siteCountries } from 'src/constants';
import { Utils } from 'src/app/utils/utilities';

@Component({
  selector: 'zip-co-country-switcher',
  templateUrl: './country-switcher.component.html',
  styleUrls: ['./country-switcher.component.scss'],
})
export class CountrySwitcherComponent {
  @Output() dropDownIsOpened: EventEmitter<any> = new EventEmitter();
  @Output() dropDownIsClosing: EventEmitter<any> = new EventEmitter();

  public showDropDown = false;
  public dropDownIsHiding = false;
  public countryOptions = siteCountries;
  public readonly COUNTRY_CODE = 'AU';
  public readonly LOCAL_STORAGE_KEYS = ['country_code', 'countryCode', 'zip:country_code'];

  constructor() {}

  onSelect(countryCode: string, path: string): void {
    Utils.setLocalStorage(this.LOCAL_STORAGE_KEYS, countryCode);
    this.toggleDropDown();
    if (countryCode !== this.COUNTRY_CODE) {
      Utils.redirect(path);
    }
  }

  public get selectedCountry(): any {
    return this.COUNTRY_CODE;
  }

  public get isSmallScreen(): boolean {
    return window.innerWidth <= 1199;
  }

  toggleDropDown = () => {
    if (!this.showDropDown) {
      this.showDropDown = true;
      setTimeout(() => {
        this.dropDownIsOpened.emit(null);
      }, 150);
    } else {
      this.dropDownIsHiding = true;
      this.dropDownIsClosing.emit(null);
      setTimeout(() => {
        this.showDropDown = false;
        this.dropDownIsHiding = false;
      }, 150);
    }
  };
}
